(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-ag-track]');
    const thumbsBar = root.querySelector('[data-ag-thumbs]');
    const items = [...root.querySelectorAll('[data-ag-item]')];
    const thumbs = [...root.querySelectorAll('[data-ag-thumb]')];
    const counter = root.querySelector('[data-ag-counter]');
    const dialog = root.querySelector('[data-ag-dialog]');
    const stage = root.querySelector('[data-ag-dialog-stage]');
    const dialogImage = root.querySelector('[data-ag-dialog-image]');
    const dialogCounter = root.querySelector('[data-ag-dialog-counter]');
    const videoButton = root.querySelector('.ag__video');
    const stageShell = root.querySelector('.ag__stage');
    const desktop = matchMedia('(min-width: 1024px)');
    const origin = root.parentElement;
    let visible = [];
    let active = 0;
    let modalIndex = 0;
    let previousOverflow = '';
    let focusReturn = null;
    let scrollFrame = 0;

    function relocate() {
      // Si l'on repasse sous 1024px alors que la modale est ouverte,
      // on la referme : le zoom n'existe plus a cette largeur.
      if (!desktop.matches && dialog.open) dialog.close();
      const product = document.querySelector('.wt-product');
      if (desktop.matches && product) product.prepend(root);
      else if (root.parentElement !== origin) origin.append(root);
      placeVideoButton();
      if (!desktop.matches) track.scrollLeft = visible[active]?.offsetLeft || 0;
    }

    function placeVideoButton() {
      if (desktop.matches && visible.length) visible[0].item.after(videoButton);
      else stageShell.after(videoButton);
    }

    function setActive(index, centerThumb = true) {
      if (!visible.length) return;
      active = Math.max(0, Math.min(index, visible.length - 1));
      thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb === visible[active].thumb)));
      counter.textContent = `${active + 1} / ${visible.length}`;
      if (centerThumb && !desktop.matches) {
        const thumb = visible[active].thumb;
        thumbsBar.scrollTo({
          left: thumb.offsetLeft - (thumbsBar.clientWidth - thumb.clientWidth) / 2,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }

    function colorFromSelection() {
      const selected = document.querySelector('.bnd--atelier [data-afm-top-color="bronze"].is-active') ? 'bronze' : document.querySelector('[data-trunk-product] [data-trunk-color].is-active')?.dataset.trunkColor || document.querySelector('.bnd--atelier')?.dataset.selectedColor || root.dataset.initialColor;
      return /bronze|champagne/i.test(String(selected)) ? 'bronze' : /black|schwarz|noir|nero|zwart|sort|czarny|svart|musta|أسود/i.test(String(selected)) ? 'black' : 'silver';
    }

    // ALTAIR : index de la taille choisie dans le bundle (0 = Carry-On S,
    // 1 = Check-In M, 2 = Check-In L). Avant que le bundle n'ait publie sa
    // selection on retombe sur 0, qui est aussi son pack par defaut.
    function sizeFromSelection() {
      const bundle = document.querySelector('.bundle-wrapper');
      if (bundle?.classList.contains('afm--trunk')) {
        const chosen = bundle.querySelector('[data-trunk-size][aria-checked="true"]')?.dataset.trunkSize || bundle.querySelector('[data-afm-trunk-size][aria-checked="true"]')?.dataset.afmTrunkSize;
        return /xl/i.test(String(chosen)) ? 1 : /(?:^|\s)l$/i.test(String(chosen)) ? 2 : 0;
      }
      if (bundle?.classList.contains('afm--pilot')) return 0;
      const raw = document.querySelector('.bnd--atelier')?.dataset.selectedSize;
      const index = Number(raw);
      return Number.isInteger(index) && index >= 0 ? index : 0;
    }

    function filter(color) {
      const bundle = document.querySelector('.bundle-wrapper');
      const family = bundle ? (bundle.classList.contains('afm--trunk') ? 'trunk' : 'original') : (root.dataset.defaultFamily || 'original');
      const activeColor = bundle?.querySelector('[data-afm-top-color="bronze"].is-active') ? 'bronze' : color || colorFromSelection();
      const chosen = family !== 'original' && (activeColor === 'bronze') ? activeColor : /black|schwarz|noir|nero|zwart|sort|czarny|svart|musta|أسود/i.test(String(activeColor)) ? 'black' : 'silver';
      const size = sizeFromSelection();
      root.dataset.family = family;
      videoButton.hidden = family !== 'original';
      root.dataset.color = chosen;
      root.dataset.size = String(size);
      visible = [];
      items.forEach((item, index) => {
        const tagged = item.dataset.size;
        // Les photos "taille" sont rendues en tete de piste : celle qui
        // correspond devient donc visible[0], donc la photo prioritaire.
        const sizeOk = tagged === undefined || Number(tagged) === size;
        const itemFamily = item.dataset.family || 'original';
        const show = itemFamily === family && (item.dataset.color === chosen || (family === 'original' && item.dataset.color === 'all')) && sizeOk;
        item.hidden = !show;
        thumbs[index].hidden = !show;
        item.classList.remove('is-hero');
        if (show) visible.push({item, thumb: thumbs[index]});
      });
      if (!visible.length) {
        items.forEach((item, index) => {
          if ((item.dataset.family || 'original') !== family || item.dataset.size !== undefined) return;
          item.hidden = false;
          thumbs[index].hidden = false;
          visible.push({item, thumb: thumbs[index]});
        });
      }
      if (!visible.length) return;
      visible[0].item.classList.add('is-hero');
      placeVideoButton();
      visible[0].item.querySelector('img').sizes = '(min-width: 1024px) 56vw, 100vw';
      visible[0].item.querySelector('img').loading = 'eager';
      track.scrollLeft = 0;
      thumbsBar.scrollLeft = 0;
      setActive(0, false);
      if (dialog.open) showModal(0);
    }

    function go(index, behavior) {
      const target = visible[Math.max(0, Math.min(index, visible.length - 1))]?.item;
      if (!target) return;
      if (desktop.matches) target.scrollIntoView({block:'center', behavior});
      else track.scrollTo({left: target.offsetLeft, behavior});
      setActive(visible.findIndex(entry => entry.item === target));
    }

    function sizeModal() {
      const item = visible[modalIndex].item;
      const source = item.querySelector('img');
      const imageWidth = Number(source.getAttribute('width')) || source.naturalWidth || 4;
      const imageHeight = Number(source.getAttribute('height')) || source.naturalHeight || 5;
      const ratio = imageWidth / imageHeight;
      dialog.style.aspectRatio = `${imageWidth} / ${imageHeight}`;
      dialog.style.width = `${Math.floor(Math.min(window.innerWidth * 0.92, window.innerHeight * 0.9 * ratio, 1000))}px`;
      dialogImage.width = imageWidth;
      dialogImage.height = imageHeight;
    }

    function showModal(index) {
      modalIndex = (index + visible.length) % visible.length;
      const item = visible[modalIndex].item;
      sizeModal();
      stage.classList.remove('is-zoomed');
      stage.scrollTo(0, 0);
      dialogImage.src = item.dataset.full;
      dialogImage.alt = item.dataset.alt;
      dialogCounter.textContent = `${modalIndex + 1} / ${visible.length}`;
    }

    function open(index, button) {
      focusReturn = button;
      showModal(index);
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      root.querySelector('[data-ag-close]').focus();
    }

    items.forEach(item => item.addEventListener('click', () => {
      // ALTAIR : pas de zoom plein ecran sur mobile / tablette.
      // Le doigt sert deja au balayage horizontal du carrousel ; la
      // modale se superposait aux autres overlays (choix du cadeau).
      if (!desktop.matches) return;
      const index = visible.findIndex(entry => entry.item === item);
      if (index >= 0) open(index, item);
    }));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const index = visible.findIndex(entry => entry.thumb === thumb);
      if (index >= 0) go(index, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
    }));
    root.querySelector('[data-ag-close]').addEventListener('click', () => dialog.close());
    root.querySelector('[data-ag-previous]').addEventListener('click', () => showModal(modalIndex - 1));
    root.querySelector('[data-ag-next]').addEventListener('click', () => showModal(modalIndex + 1));
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      if (focusReturn?.isConnected) focusReturn.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showModal(modalIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showModal(modalIndex + 1); }
    });
    window.addEventListener('resize', () => { if (dialog.open) sizeModal(); });
    stage.addEventListener('click', () => stage.classList.toggle('is-zoomed'));
    let touchX = 0;
    stage.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', event => {
      const delta = event.changedTouches[0].clientX - touchX;
      if (!stage.classList.contains('is-zoomed') && Math.abs(delta) > 60) showModal(modalIndex + (delta < 0 ? 1 : -1));
    }, {passive:true});
    track.addEventListener('scroll', () => {
      if (desktop.matches && root.dataset.family !== 'trunk') return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const index = visible.reduce((best, entry, i) =>
          Math.abs(entry.item.offsetLeft - track.scrollLeft) < Math.abs(visible[best].item.offsetLeft - track.scrollLeft) ? i : best, 0);
        setActive(index);
      });
    }, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(active + (event.key === 'ArrowRight' ? 1 : -1), 'smooth');
    });
    // Warm the first image of each color once the main product image has loaded.
    // Hidden lazy images otherwise start fetching only after a family switch.
    const warmQueue = [];
    const warmed = new Set();
    function warmFamily(family) {
      if (warmed.has(family)) return;
      warmed.add(family);
      for (const color of ['silver', 'black', 'bronze']) {
        const item = items.find(entry => entry.dataset.family === family && entry.dataset.color === color);
        const source = item?.querySelector('img');
        const url = source?.getAttribute('src');
        if (!url) continue;
        const preload = new Image();
        preload.decoding = 'async';
        preload.src = url;
        warmQueue.push(preload);
      }
    }
    const startWarming = () => { warmFamily('trunk'); };
    if ('requestIdleCallback' in window) requestIdleCallback(startWarming, {timeout: 1800});
    else window.addEventListener('load', startWarming, {once:true});
    document.querySelectorAll('[data-afm-tab]').forEach(tab => {
      tab.addEventListener('pointerenter', () => warmFamily(tab.dataset.afmTab), {passive:true});
      tab.addEventListener('focus', () => warmFamily(tab.dataset.afmTab), {passive:true});
    });
    document.addEventListener('altair:selection-change', () => { if (root.isConnected) filter(colorFromSelection()); });
    document.addEventListener('variant:change', () => { if (root.isConnected) filter(colorFromSelection()); });
    desktop.addEventListener('change', relocate);
    filter(colorFromSelection());
    relocate();
  }

  function boot() {
    document.querySelectorAll('[data-altair-gallery]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

